import styled from '@emotion/styled'

export default styled.div`
  height: 100%;
  display: grid;
  grid-gap: 2rem;
  grid-template-rows: 1fr min-content;

  div:first-of-type {
    align-content: flex-start;
  }
`
